'use client'

import { useEffect } from 'react'
import type { MastheadLayoutId } from '@/lib/category-masthead-layout'
import {
  rememberCategoryMastheadLayout,
  rememberHomeMastheadLayout,
} from '@/lib/masthead-layout-cache'

/** Kategori sayfası — sonraki loading için layout’u cache’le */
export function CategoryMastheadLayoutHint({
  slug,
  layout,
  showMasthead,
}: {
  slug: string
  layout: MastheadLayoutId
  showMasthead: boolean
}) {
  useEffect(() => {
    rememberCategoryMastheadLayout(slug, layout, showMasthead)
  }, [slug, layout, showMasthead])
  return null
}

/** Ana sayfa — home masthead layout’unu cache’le */
export function HomeMastheadLayoutHint({ layout }: { layout: MastheadLayoutId }) {
  useEffect(() => {
    rememberHomeMastheadLayout(layout)
  }, [layout])
  return null
}
